import { render, staticRenderFns } from "./mc.vue?vue&type=template&id=2b394ab3&scoped=true&"
import script from "./mc.vue?vue&type=script&lang=js&"
export * from "./mc.vue?vue&type=script&lang=js&"
import style0 from "./mc.vue?vue&type=style&index=0&id=2b394ab3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b394ab3",
  null
  
)

export default component.exports